module.exports = __webpack_public_path__ + "img/volume-off.c2448792.svg";